<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
input.mx-input {
  height: 40px !important;
}
</style>

<template>
  <v-container fluid>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        ใบเสนอราคา
      </div>
      <v-spacer></v-spacer>
      <v-btn color="success" elevation="0" dark @click="create_form()">
        <v-icon left>mdi-file-plus</v-icon>สร้างใบเสนอราคา
      </v-btn>
    </v-layout>

    <v-divider class="my-2"></v-divider>
    <SearchBar :Page="'Quotation'"></SearchBar>
    <v-layout
      v-resize="onResize"
      column
      class="pt-5 d-flex justify-space-between"
    >
      <v-data-table
        :headers="headers"
        :items="quotation"
        :items-per-page="20"
        class="elevation-1"
        :search="search"
        @click:row="handleRowClick"
      >
        <template v-slot:item.CREATED_AT="{ item }">{{
          item.CREATED_AT | formatDate
        }}</template>
        <template v-slot:item.total_price="{ item }">{{
          item.total_price | delimeter
        }}</template>
        <template v-slot:item.DOC_STATUS="{ item }">
          <DocStatus :TableData="item" :Page="'Quotation'"></DocStatus>
        </template>
        <template v-slot:item.detail="{ item }">
          <TableMenu :TableData="item" :Page="'Quotation'"></TableMenu>
        </template>
      </v-data-table>
    </v-layout>
    <EmailModal
      ref="Quotation_Mail"
      :Page="'Quotation'"
    ></EmailModal>
  </v-container>
</template>

<script>
import TableMenu from '../components/TableMenu'
import SearchBar from '../components/SearchBar'
import EmailModal from '../components/EmailModal'
import DocStatus from "../components/DocStatus";
import printJS from 'print-js'
import XLSX from "xlsx";

import { mapGetters, mapMutations, mapActions } from "vuex";
import moment from 'moment'
export default {
  name: "Quotation",
  components: {
    TableMenu,
    SearchBar,
    EmailModal,
    DocStatus
  },
  data: () => ({
    passData: Array,
    search: "",
    headers: [
      {
        text: "วันที่",
        align: "start",
        sortable: false,
        value: "CREATED_AT",
      },
      { text: "เลขที่เอกสาร", value: "qt_id" },
      { text: "ชื่อลูกค้า/ชื่อโปรเจ็ค", value: "cus_name" },
      { text: "ยอดรวมสุทธิ", value: "total_price" },
      { text: "สถานะ", value: "DOC_STATUS" },
      { text: "", value: "detail" },
    ],
    quotation: [],
  }),
  created() {
    this.$store.commit('Quotation/SET_IS_EDIT', false)
  },
  mounted() {
console.log('wejfo')
    this.list_quotation()
  },
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2)
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return x

    },
    formatDate(data) {
      return moment(data).format('DD-MM-YYYY')
    }
  },
  computed: {
    ...mapGetters({
      GET_QT: "Quotation/GET_QUOTATION",
      GET_SE_TEXT: "Drawer/GET_SE_TEXT",
      GET_SE_TIME: "Drawer/GET_SE_TIME"
    })
  },
  methods: {
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER",
      EDIT_QT: "Quotation/SET_IS_EDIT",
      SET_QT: "Quotation/SET_ELEMENT",
      SET_ALL_QT: "Quotation/SET_ALL_ELEMENT",
      SET_ALL_QT_PRODUCT: "Quotation/SET_PRODUCT_LIST",
      SET_STEP: "Drawer/SET_STEP",
      SET_SE_TEXT: "Drawer/SET_SE_TEXT",
      SET_SE_TIME: "Drawer/SET_SE_TIME"
    }),
    handleRowClick(item) {
      // this.$store.commit('Quotation/SET_IS_EDIT', true)
      // this.$store.commit("Quotation/SET_ELEMENT", {
      //   key: "CUSTOMER_ID",
      //   value: item.CUSTOMER_ID,
      // });
      // //console.log(tbl_data.qt_id)
      // this.$router.push({ path: '/form' })
    },
    list_quotation(time, text) {

      let date_obj = {
        SE_DATE1: typeof (time) == 'undefined' ? null : time[0],
        SE_DATE2: typeof (time) == 'undefined' ? null : time[1],
      }
      this.$token_api
        .post("/list-quotation", date_obj)
        .then((response) => {
          console.log(response.data.data)
          this.quotation = response.data.data;
          this.search = text
          // console.log(response.data.data)
        })
        .catch((err) => { });
    },
    send_email(tbl_data) {
      this.$refs.Quotation_Mail.openModal(tbl_data)
    },
    download_quotation(tbl_data) {
      this.LOADER(true)
      this.$download_api.get(`/donwload-quotation/${tbl_data.qt_id}`).then((response) => {

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'ใบเสนอราคา_' + tbl_data.qt_id + '.pdf');
        document.body.appendChild(link);
        link.click();
        this.LOADER(false)
      }).catch((err) => {
        console.log(err)
        this.LOADER(false)
      });
    },
    print_quotation(tbl_data) {
      this.LOADER(true)
      this.$download_api.get(`/donwload-quotation/${tbl_data.qt_id}`).then((response) => {

        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(response.data, 'ใบเสนอราคา_' + tbl_data.qt_id + '.pdf'); //IE is the worst!!!
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          printJS(url)
        }
        this.LOADER(false)
      }).catch((err) => {
        console.log(err)
        this.LOADER(false)
      });
    },
    edit_quotation(tbl_data) {
      this.EDIT_QT(true)
      this.SET_QT({ key: "QUOTATION_ID", value: tbl_data.qt_id });
      this.$router.push({ path: '/form' })
    },
    remove_quotation(tbl_data) {
      this.$swal({
        title: "ต้องการลบข้อมูลหรือไม่",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      })
        .then((result) => {
          if (result.value) {
            // console.log(tbl_data.qt_id);
            this.$token_api
              .delete("/delete-quotation", {
                data: {
                  QUOTATION_ID: tbl_data.qt_id,
                }
              })
              .then((response) => {
                this.list_quotation()
              })
              .catch((err) => { });
          }
        });
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    create_form() {
      this.SET_QT({ key: "IS_CONTRACT", value: 2 })
      this.$router.push({ path: "/form" });
    },
    export_quotation(time, text) {
      let date_obj = {
        SE_DATE1: typeof (time) == 'undefined' ? null : time[0],
        SE_DATE2: typeof (time) == 'undefined' ? null : time[1],
      }
      let xls_json = []
      this.$token_api
        .post("/list-quotation", date_obj)
        .then((response) => {
          response.data.data.forEach((element) => {
            xls_json.push({
              'วันที่เอกสาร': moment(element.CREATED_AT).format('DD-MM-YYYY'),
              'เลขที่เอกสาร': element.qt_id,
              'ชื่อลูกค้า/ชื่อโปรเจค': element.cus_name,
              'ยอดรวมสุทธิ': element.total_price
            });
          });
          const dataWS = XLSX.utils.json_to_sheet(xls_json);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, dataWS);
          XLSX.writeFile(wb, "ข้อมูลใบเสนอราคา.xlsx");
        })
        .catch((err) => {
          this.$swal({
            title: "เกิดช้อผิดพลาด",
            icon: "warning",
            text: `เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง\n${err}`,
            timer: 2000
          })
        });
    }
  },

};
</script>
